import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "partners" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Partners = _resolveComponent("Partners")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Logo),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Partners, { msg: "Partners" })
    ])
  ], 64))
}